import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from "react-router-dom"
import { debounce } from "lodash"
import PaginatedSelect from '../../../forms/components/PaginatedSelect'
import { Form } from "antd"

import {
    fetchSupplyAccounts,
    selectSupplyAccounts,
    selectPagination,
    selectTotal,
    selectSupplyAccountSearch,
    searchSupplyAccounts
} from '../../../supplyAccounts/supplyAccountsSlice'

export default function ReportSupplyAccounts() {
    const { clientId } = useParams()

    const dispatch = useDispatch()

    const pagination = useSelector(selectPagination)

    const handleSearch = debounce((value) => {
        // make sure they've typed at least 3 characters
        if (value && value.length >= 3) {
            dispatch(searchSupplyAccounts(value, `clients/${clientId}/supply_accounts/search`))
        }
    }, 1000)

    return (
        <div>
            <Form.List name="form_data">
                {
                    fields => (
                        <Form.Item label="Supply Account" name="supply_account_ids">
                            <PaginatedSelect
                                mode='multiple'
                                placeholder='Search supply accounts...'
                                onSearch={handleSearch}
                                paginationSelector={selectSupplyAccounts}
                                paginationTotalSelector={selectTotal}
                                loadPaginatedData={(p) => fetchSupplyAccounts(p, `clients/${clientId}/supply_accounts`)}
                                searchSelector={selectSupplyAccountSearch}
                                renderOptionValue={(o) => `Supply account: ${o.account_number} - ${o.name}`}
                            />
                        </Form.Item>
                    )
                }
            </Form.List>
        </div>
    )
}
